import React from 'react';
import ReactDOM from 'react-dom';
import 'es6-symbol/implement';
import ConfiguratorRouter from './react/ConfiguratorRouter.jsx';

class ItkConfigurator
{
	static init(params) {
		ReactDOM.render(
			<ConfiguratorRouter type={params.configuratorType} locale={params.locale ? params.locale : 'ru'} />,
			params.container
		);
	}
}

module.exports = ItkConfigurator;



// WEBPACK FOOTER //
// ./src/ItkConfigurator.jsx